"use client";
import { PageContainer } from "@components";
import { getTransitions, LangProps } from "i18n";
import React, { FC, use } from "react";

import { PageActionBar } from "./page-action-bar";
import { RegularInvestment } from "./regular-investment";

const AssetDashboard: FC<LangProps> = props => {
  const params = use(props.params);
  const t = getTransitions(params.lang);
  return (
    <PageContainer extra={<PageActionBar />} title={t("asset_dashboard.title")}>
      <RegularInvestment />
    </PageContainer>
  );
};

export default AssetDashboard;
